import React from 'react';

import { Link } from 'react-router-dom';

import { Helmet } from "react-helmet";

const OVERRIDE_COLOR = 'rgb( 183, 28, 28 )';

const newsletterApril2023 = ({ imagePrefix }) => {
  return (
    <div className="content-container article">
      <Helmet>
        <title>The Good News - April 2023 | Elevation of the Holy Cross Sacramento</title>
      </Helmet>

      <div className="header">
        <div className="eyebrows">
          <div className="left">
            Quarterly Newsletter
          </div>
          <div className="right">
            April 2023
          </div>
        </div>

        <h1 style={{ color: OVERRIDE_COLOR }}>The Good News</h1>
        <h2>Elevation of the Holy Cross Orthodox Church, Sacramento</h2>
      </div>

      <div className="body">
        <div className="cols">
          <div className="left">

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Rector's Reflection - The Pilgrimage to Pascha
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <div style={{ float: 'left', maxWidth: '50%', marginRight: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-april-2023-1.jpg') } alt="Rector's Reflection - The Pilgrimage to Pascha" />
                </div>

                <p>
                  Who among us, at some point in our life, hasn't wanted to travel to the Holy Land? To walk where Jesus walked, and to see and experience the holy places we read about. More than that, who hasn't wished (at least once) to have been there with Jesus in the 1st Century; to hear our Lord preach, to walk with Him, to see Him, to be with Him at the Last Supper? And perhaps we've also asked ourselves: would I have fled like the other disciples when Jesus was arrested? Would I have been there at the Cross?  Where would I have been Pascha morning?
                </p>
                <p>
                  Countless Christians throughout the centuries have been inspired by similar thoughts to make a pilgrimage to the Holy Land. In the Middle Ages, a pilgrim from the West who made the long and difficult journey was honored with the special title of “Palmer,” a name derived from the Cross of folded palm leaves they received in Jerusalem and wore on their hats or staff.  Many faithful still today make a pilgrimage to visit and pray at the holy sites where our Lord was born, walked, suffered and rose again, as several of our own parishioners have done. But we should also understand that all of us are called to make this Pilgrimage spiritually every year with our Lord Jesus Christ during Holy Week, a pilgrimage that doesn't require us to travel far from home, but to travel deep into the heart.
                </p>
                <p>
                  In one of the hymns for Holy Monday, we sing: <em>As the Lord went to His voluntary Passion, He said to His apostles on the way: ‘Behold, we go up to Jerusalem, and the Son of Man shall be betrayed as it is written of Him.' Come, then, and let us also journey with Him, purified in mind; let us be crucified with Him and die for His sake to the pleasures of this life, that we may also live with Him and hear Him say: ‘No longer do I ascend to the earthly Jerusalem to suffer, but I ascend to My Father and your Father…and I shall raise you up to the Jerusalem on High in the Kingdom of Heaven.”</em>
                </p>
                <p>
                  Holy Week is our invitation to embark on a Pilgrimage. It's an invitation to journey with our Lord to the Cross that we might Rise with Him in joy on Pascha night.  Maybe this is our first Holy Week in the Church or perhaps we've made this pilgrimage many times before. Perhaps we've drifted away from God and the Church and now this is our call to return. This is our invitation: Come with Me, invites our Lord!  And it's something that we can all do if we just make the time for it, if we choose to quiet the noise, to make the time be at the services, to read the Gospel at home each morning and to quietly reflect on our these events and God's love for us each night before we go to bed.
                </p>
                <p>
                  Just before our Lord went to raise Lazarus from the dead, some of his disciples were afraid to return to Jerusalem because they knew the Jewish leaders were already plotting to kill Jesus. But Thomas spoke out and boldly declared: <em>Let us also go, that we may die with Him!</em> Let us take courage like Thomas and embark upon this Holy Pilgrimage to Golgotha, that we too may sing: <em>We venerate thy Passion, O Christ; We venerate thy Passion, O Christ; We venerate thy Passion, O Christ. Show us also Thy glorious Resurrection!</em> (15th Antiphon of Great and Holy Friday)
                </p>
              </div>
            </div>

            <div className="section" style={{ marginBottom: '32px', paddingBottom: '16px', borderBottom: '1px solid rgba( 0, 0, 0, .2 )' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                2023 Lenten Retreat with Mother Melania
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <div style={{ float: 'right', maxWidth: '50%', marginLeft: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-april-2023-2.jpg') } alt="2023 Lenten Retreat with Mother Melania" />
                </div>

                <p>
                  On Sunday, 12 March, after Liturgy, Mother Melania, the abbess of Holy Assumption Monastery in Calistoga, CA, gave us a Lenten talk. She emphasized that the goal of Lent is that we learn to love God and others more. She focused on three sins to be combated: gluttony, avarice, and (of course) pride. Gluttony, we should understand, is more than simply eating too much food; it also entails eating “at the wrong times” as well as what she called “dainties” (all of our superfluous snacks). Mother Melania called gluttony a “bedrock passion”, which needs to be corrected by the “bedrock virtue” of self-control. <em>Avarice</em> or coveting is our preoccupation with things (acquiring this, that, and the other because we think that we need them). During Great Lent, almsgiving is our way to combat the sin of avarice, but Mother noted that almsgiving is more than merely giving money; we should also give of our time, which may mean <em>visiting</em> the sick and the needy. <em>Pride</em> consists of our denial of God and our contempt of people. It's easier for us to recognize the worldly pride that stems from power and money, but spiritual pride is much more innocuous. It's easy for us to become Pharisees if we focus on the externals of
Great Lent, especially the fasting rules. To combat our spiritual pride, we must constantly bear in mind that we are sinners, and we must be constantly repenting. Finally, so as to illustrate these notions, Mother Melania read us a children's story she had written titled <em>Pascha at the Duckpond</em>. The main character is Rigid Rooster, who is so obsessed with the rules of Great Lent that he nearly missed the point of Great Lent – Pascha itself – that Christ has indeed trampled down death by death and has bestowed upon us eternal life.
                </p>
              </div>
            </div>

            <div className="section" style={{ marginBottom: '32px', paddingBottom: '16px', borderBottom: '1px solid rgba( 0, 0, 0, .2 )' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Snow day!
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <img src={ require('../../../assets/images/news/newsletter-april-2023-3.jpg') } alt="Snow day 1" />

                <div style={{ float: 'right', maxWidth: '50%', marginTop: '1rem', marginLeft: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-april-2023-4.jpg') } alt="Snow day 2" style={{ marginTop: '1rem', marginBottom: '1rem' }} />
                </div>

                <p>
                  On Sat March 18th, after a memorial liturgy, many of us met at a snow hill just off the Fresh Pond exit on Hwy 50. The roads were clear so the drive didn't require snow chains. The snow hill wasn't crowded. The weather was perfect, a windless, sunny day. Many of our young children zipped down the hill on sleds, and some even sat down in their snow pants and slid down the slope on their bottoms. A few dug in the snow and made tiny snowmen. We all had fun enjoying the snow and being together. It was a lovely time. I hope we can do this again next year. Please plan to join us! - Matushka Nina
                </p>
              </div>
            </div>

            <div className="section" style={{ marginBottom: '32px', paddingBottom: '16px', borderBottom: '1px solid rgba( 0, 0, 0, .2 )' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Orthodox Church Capital Improvement Fund
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <img src={ require('../../../assets/images/news/newsletter-april-2023-5.png') } alt="OCCIF Board of Directors" />

                <p>
                  On Monday, February 20, Fr. Timothy welcomed the Board of Directors of the <strong>Orthodox Church Capital Improvement Fund</strong> (OCCIF) to Holy Cross for OCCIF's Annual Meeting. Present at the meeting were the V. Rev.Fr. John Dresko, President; Mat. Theodora Blom, Treasurer; Linda Koshell, Corporate Secretary; and Board Members John Della Monica, Mark Linnehan, and Pdja. Katherine Vitko.  One of the highlights of the meeting was the election of Kathy Pieracci to the OCCIF Board of Directors.  During their lunch break (provided by Kathy, of course!), those present were shown our beautiful chapel, where pictures were taken.  OCCIF has approved Holy Cross for a loan to complete the first phase of its construction project. OCCIF helps parishes, missions, and monastic communities of the canonical jurisdictions of the Orthodox Church in the United States acquire, build, remodel, and refinance church-related properties, furthering the great mission of Christ's Church.
                </p>
              </div>
            </div>

            <div className="section" style={{ marginBottom: '32px', paddingBottom: '16px', borderBottom: '1px solid rgba( 0, 0, 0, .2 )' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Feast of Theophany - The Great Blessing of the Waters
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <img src={ require('../../../assets/images/news/newsletter-april-2023-6.jpg') } alt="The Great Blessing of the Water 1" />

                <div style={{ float: 'right', maxWidth: '50%', marginTop: '1rem', marginLeft: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-april-2023-7.jpg') } alt="The Great Blessing of the Water 2" style={{ marginTop: '1rem', marginBottom: '1rem' }} />
                </div>

                <p>
                  Following the Celebration of the <strong>Feast of Theophany</strong>, when we commemorate our Lord Jesus Christ's baptism by John in the Jordan River, faithful from Holy Cross once again traveled to the American River to celebrate the <strong>great blessing of the waters</strong>. On Theophany, we reflect on how He who is without sin cleansed the waters, and through them, all of creation at His baptism. And the Church continues to the present day participating in the sanctification and salvation of the world. The blessing of the waters – an element necessary for life – recognizes that their ultimate source and the source of all life is God Himself. Through this service, not only is our local river blessed, but as the waters flow out to sea, our beautiful state, the ocean and, through the mixing of the waters, the whole creation receives a blessing. How wondrous are Thy works O Lord, in Wisdom hast Thou made them all!
                </p>
              </div>
            </div>

            <div className="section" style={{ marginBottom: '32px', paddingBottom: '16px', borderBottom: '1px solid rgba( 0, 0, 0, .2 )' }}>
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Progress on our Building Program continues!
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <p>
                  Progress on our Building Program continues.
                  Currently, our Great Lent matching donation
                  challenge is underway, and we've already held
                  several successful fundraising events, such as
                  the Blini Luncheon and our first-ever Yard
                  Sale. We plan to hold more fundraising events
                  this year. 
                </p>

                <p>
                  Our permit application is currently under
                  review by Sacramento County, but our team
                  has been working hard to respond to all of the
                  questions and further studies required so we
                  can start acquiring bids for the work. 
                </p>

                <p>
                  Please keep this project in your prayers, as
                  we hope to obtain approvals from the County
                  in the coming months, and be able to begin
                  work on the site improvements phase this
                  year!
                </p>
              </div>
            </div>

          </div>
        </div>

        <div className="cols">
          <div className="left">

            

            <div className="section">
              <h2 className="title" style={{ color: OVERRIDE_COLOR }}>
                Holy Week & Pascha Schedule
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <p>
                  Fri. 4/7 Vespers of Lazarus Saturday, 6:00 PM
                </p>
                <p>
                  Sat. 4/8 Divine Liturgy (Lazarus Saturday), 9:00 AM (work party after)
	                <br/>
                  <span style={{ opacity: 0 }}>Sat. 4/8 </span> Vigil of Palm Sunday, 5:30 PM
                </p>
                <p>
                  Sun. 4/9 Divine Liturgy (Palm Sunday), 9:00 AM
	                <br/>
                  <span style={{ opacity: 0 }}>Sun. 4/9 </span> Bridegroom Matins of Great & Holy Monday, 6:00 PM
                </p>
                <p>
                  Mon. 4/10 Bridegroom Matins of Holy Tuesday, 6:00 PM
                </p>
                <p>
                  Tue. 4/11 Bridegroom Matins of Holy Wednesday, 6:00 PM
                </p>
                <p>
                  Wed. 4/12 Matins of Holy Thursday, 6:00 PM
                </p>
                <p>
                  Thu. 4/13 Vesperal Divine Liturgy of Holy Thursday, 9:00 AM
	                <br/>
                  <span style={{ opacity: 0 }}>Thu. 4/13 </span> Matins of Holy Friday - 12 Passion Gospels, 6:00 PM
                </p>
                <p>
                  Fri. 4/14 Royal Hours, 9:00 AM
	                <br/>
                  <span style={{ opacity: 0 }}>Fri. 4/14 </span> Vespers of Holy Friday (Burial Service), 3:00 PM
	                <br/>
                  <span style={{ opacity: 0 }}>Fri. 4/14 </span> Matins of Holy Saturday, 6:00 PM
                </p>
                <p>
                  Sat. 4/15 Vesperal Divine Liturgy of Holy Saturday, 9:00 AM
	                <br/>
                  <span style={{ opacity: 0 }}>Sat. 4/15 </span> PASCHAL VIGIL (Nocturns, Matins & Divine Liturgy), 11:00 PM
                </p>
                <p>
                  Sun. 4/16  Paschal Vespers, 2:30 PM (potluck & egg hunt after)
                </p>
                <p>
                  Wed. 4/19 Vespers of Bright Thursday, 6:00 PM
                </p>
                <p>
                  Thu. 4/20 Bright Thursday Divine Liturgy & Procession, 9:00 AM
                </p>
              </div>
            </div>

          </div>
        </div>

        <div className="article-footer">
          9000 Jackson Rd, Sacramento, CA 95826 <Link to={ `/` }>holycrosssacramento.org</Link><br/>
          Mailing: 2443 Fair Oaks Blvd #295, Sacramento, CA 95825
        </div>
      </div>
    </div>
  );
}

export default newsletterApril2023;
